const LOAD_DATA_LANGUAGE_SKILLS           = 'LOAD_DATA_LANGUAGE_SKILLS'
const LOAD_DATA_LANGUAGE_SKILLS_SUCCESS   = 'LOAD_DATA_LANGUAGE_SKILLS_SUCCESS'
const LOAD_DATA_LANGUAGE_SKILLS_FAILED    = 'LOAD_DATA_LANGUAGE_SKILLS_FAILED'
const UNMOUNT_DATA_LANGUAGE_SKILLS        = 'UNMOUNT_DATA_LANGUAGE_SKILLS'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const languageSkillsReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_LANGUAGE_SKILLS:
      return {
        ...state,
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case LOAD_DATA_LANGUAGE_SKILLS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        pagination: {
          total: action.payload.pagination.total,
          page: action.payload.pagination.page,
          perpage: action.payload.pagination.perpage
        }
      }
    case LOAD_DATA_LANGUAGE_SKILLS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case UNMOUNT_DATA_LANGUAGE_SKILLS:
      return { 
        ...state, 
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    default:
      return state
  }
}

export default languageSkillsReducer;